import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0ea5e9',
      dark: '#0284c7',
      light: '#38bdf8',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#0f172a',
      dark: '#020617',
      light: '#334155',
      contrastText: '#ffffff',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#0f172a',
      secondary: 'rgba(15, 23, 42, 0.62)',
    },
    divider: 'rgba(15, 23, 42, 0.08)',
    success: { main: '#059669' },
    warning: { main: '#d97706' },
    error: { main: '#e11d48' },
  },
  typography: {
    fontFamily:
      '"Inter", "Segoe UI", system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
    h1: {
      fontWeight: 700,
      letterSpacing: '-0.045em',
      lineHeight: 1.05,
      fontSize: '3.75rem',
      '@media (max-width:900px)': { fontSize: '2.5rem' },
    },
    h2: {
      fontWeight: 700,
      letterSpacing: '-0.04em',
      lineHeight: 1.12,
      fontSize: '2.5rem',
      '@media (max-width:900px)': { fontSize: '1.85rem' },
    },
    h3: {
      fontWeight: 700,
      letterSpacing: '-0.03em',
      lineHeight: 1.2,
      fontSize: '1.75rem',
    },
    h4: {
      fontWeight: 600,
      letterSpacing: '-0.025em',
      fontSize: '1.35rem',
    },
    h5: {
      fontWeight: 600,
      letterSpacing: '-0.02em',
    },
    h6: {
      fontWeight: 600,
      letterSpacing: '-0.015em',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    body1: {
      lineHeight: 1.7,
    },
    body2: {
      lineHeight: 1.65,
    },
  },
  shape: {
    borderRadius: 12,
  },
  shadows: [
    'none',
    '0 1px 2px rgba(15,23,42,0.04)',
    '0 4px 16px rgba(15,23,42,0.06)',
    '0 8px 24px rgba(15,23,42,0.07)',
    '0 16px 40px rgba(15,23,42,0.08)',
    '0 24px 56px rgba(15,23,42,0.1)',
    '0 24px 56px rgba(15,23,42,0.1)',
    '0 24px 56px rgba(15,23,42,0.1)',
    '0 24px 56px rgba(15,23,42,0.1)',
    '0 24px 56px rgba(15,23,42,0.1)',
    '0 24px 56px rgba(15,23,42,0.1)',
    '0 24px 56px rgba(15,23,42,0.1)',
    '0 24px 56px rgba(15,23,42,0.1)',
    '0 24px 56px rgba(15,23,42,0.1)',
    '0 24px 56px rgba(15,23,42,0.1)',
    '0 24px 56px rgba(15,23,42,0.1)',
    '0 24px 56px rgba(15,23,42,0.1)',
    '0 24px 56px rgba(15,23,42,0.1)',
    '0 24px 56px rgba(15,23,42,0.1)',
    '0 24px 56px rgba(15,23,42,0.1)',
    '0 24px 56px rgba(15,23,42,0.1)',
    '0 24px 56px rgba(15,23,42,0.1)',
    '0 24px 56px rgba(15,23,42,0.1)',
    '0 24px 56px rgba(15,23,42,0.1)',
    '0 24px 56px rgba(15,23,42,0.1)',
  ],
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: { scrollBehavior: 'smooth' },
        body: {
          backgroundColor: '#ffffff',
          color: '#0f172a',
          WebkitFontSmoothing: 'antialiased',
        },
        '::selection': {
          background: 'rgba(14,165,233,0.18)',
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: 999,
          padding: '10px 20px',
          fontSize: 14,
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 8px 24px rgba(14,165,233,0.28)',
          },
        },
        outlined: {
          borderColor: 'rgba(15,23,42,0.12)',
          '&:hover': {
            borderColor: '#0ea5e9',
            backgroundColor: 'rgba(14,165,233,0.04)',
          },
        },
        sizeLarge: {
          padding: '12px 24px',
          fontSize: 15,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#0284c7',
        },
      },
    },
  },
});

export default theme;
